import { Injectable } from '@angular/core';
import { UtilService } from '../services/util.service';
import { UserModel } from '../models/user/user.model';
import { AxiosHttpRequest } from '../infra/axioshttprequest';
import axios from 'axios';
import { Setups } from '../services/setup';
import { StorageService } from '../services/storage.service';
import { SettingId } from '../enums/settingid.enum';
import { Http, URLSearchParams, Headers, RequestOptions } from '@angular/http';
import { UserLoginModel } from '../models/user/userlogin.model';

@Injectable()
export class UserService{
    url: string;
    protocol: string;

    constructor(
        private axiosHttpRequest: AxiosHttpRequest
        , private util: UtilService
        , private storageService: StorageService
        , private setups: Setups
        , private http: Http
    ) {
        if (location.protocol == 'file:') this.protocol = 'https:';
        else this.protocol = location.protocol;
    }

    retrieveUserSalesrepList(userId: any, setting_id: string) {
        const params = {
            userId: userId
            , setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'user/GetUserSalesrepList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveSalesrepSetupList(salesrepCode: string, setting_id: string) {
        const params = {
            salesrepCode: salesrepCode
            , setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'user/GetSalesrepSetupList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    getUserInfo(uid: number) {
        let user = new UserModel();
        user.user_id = uid;

        this.url = this.protocol + this.util.getWebServiceURL() + 'user/GetUserInfo';
        
        return this.axiosHttpRequest.post(this.url, user);
    }

    getLatestAppInformation(){
        this.url = this.protocol + this.util.getWebServiceURL() + 'user/getAppInformation';
        return axios.get(this.url);
    }

    getUserType(oid: string, email: string) {
        let user = new UserModel();
        user.oid = oid;
        user.email = email;

        this.url = this.protocol + this.util.getWebServiceURL() + 'user/GetUserType'
        return this.axiosHttpRequest.post(this.url, user);
    }

    getImpersonateList(login: string, otp, user_name: string, password: string) {
        let user = new UserModel();
        user.login = login;
        user.otp = otp;
        user.user_name = user_name;
        user.password = password;

        this.url = this.protocol + this.util.getWebServiceURL() + 'user/GetImpersonateList'
        return this.axiosHttpRequest.post(this.url, user);
    }

    stopImpersonate(setting_id: string, login: string, impersonateLogin: string) {
        const params = {
            setting_id: setting_id
            , login: login
            , impersonateLogin: impersonateLogin
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'user/StopImpersonate';
        return this.axiosHttpRequest.get(this.url, params);
    }

    startImpersonate(setting_id: string, login: string, impersonateLogin: string) {
        const params = {
            setting_id: setting_id
            , login: login
            , impersonateLogin: impersonateLogin
        }
        this.url = this.protocol + this.util.getWebServiceURL() + 'user/StartImpersonate';
        return this.axiosHttpRequest.get(this.url, params);
    }

    checkingEmail(email: string) {
        var params = new URLSearchParams();
        params.set('email', email);

        let options = new RequestOptions({params: params});

        this.url = this.protocol + this.util.getWebServiceURL() + 'user/CheckEmail';
        return this.http.get(this.url, options).map(e => e.json());
    }

    /**
     * CCLIORDER-2818
     * Check if the MOV has surcharge
     */
    isHKSurchargeApplicable() {
        if (this.storageService.getSettingId() !== SettingId.HK) {
            return false;
        }

        return this.storageService.getSetupValue(this.setups.AllowSurchargeOnMOV.ID) === "1";
    }

    authenticateUser(username: string, password: string){
        let user = new UserLoginModel();
        user.login = username;
        user.password = password;
        
        this.url = this.protocol + this.util.getWebServiceURL() + 'user/AuthenticateUser';
        return this.http.post(this.url, user).map(e => e.json());
    }  
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts